module.exports = __webpack_public_path__ + "static/images/cover_D6.4b8093f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_D6.png
// module id = K3ps
// module chunks = 8